import React from 'react';
import firebase from 'firebase';
import Phone from 'phone';
import { Formik, Form } from 'formik';
import { object, string } from 'yup';

import TextField from '../components/TextField';

const Signup = ({ history }) => {
  const handleSignup = async ({ firstName, lastName, email, phone, password }) => {
    try {
      const { user } = await firebase.auth().createUserWithEmailAndPassword(email, password);
      
      await firebase.database().ref(`users/${user.uid}`)
        .set({
          name: {
            firstName,
            lastName,
          },
          email,
          phone: Phone(phone)[0],
          role: 'admin',
          createdAt: new Date(),
        });

      // navigate to first screen after a successful signup
      history.push('/orders');
    } catch (error) {
      alert(error.message);
    }
  }
  return (
    <div className="row">
      <div className="col-xs-12 col-lg-6">
        <h3 className="page-header">Signup</h3>
        <Formik
          initialValues={{ email: '', password: '' }}
          validationSchema={object().shape({
            firstName: string().required('first name is a required field'),
            lastName: string().required('last name is a required field'),
            email: string().email().required(),
            password: string().required(),
          })}
          onSubmit={handleSignup}
          render={({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-xs-12 col-md-6">
                  <TextField label="First Name" name="firstName" />
                </div>
                <div className="col-xs-12 col-md-6">
                  <TextField label="Last Name" name="lastName" />
                </div>
              </div>
              <TextField type="email" label="Email Address" name="email" />
              <TextField label="Phone Number" name="phone" />
              <TextField type="password" label="Password" name="password" />
              <button type="submit" className="btn btn-primary">Sign Up</button>
            </Form>
          )}
        />
      </div>
    </div>
  );
}

export default Signup;
